import React from "react";
import { Input } from "components/bootstrap";
import { optionableLabel } from "components/configurationforms/FieldHelpers";
const DropdownField = ({
  autoFocus = false,
  field,
  onChange,
  title,
  typeName,
  value = "",
  addPlaceholder = false
}) => {
  const formatOption = (key, displayValue, disabled = false) => /* @__PURE__ */ React.createElement("option", { key: `${typeName}-${title}-${key}`, value: key, id: key, disabled }, displayValue);
  const handleChange = (event) => {
    onChange(title, event.target.value);
  };
  const options = Object.entries(field.additional_info.values).map(([k, v]) => formatOption(k, v));
  if (addPlaceholder) {
    options.unshift(formatOption("", `Select ${field.human_name || title}`, true));
  }
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `${typeName}-${title}`,
      name: `configuration[${title}]`,
      label: optionableLabel(field),
      type: "select",
      value,
      help: field.description,
      onChange: handleChange,
      autoFocus,
      required: !field.is_optional
    },
    options
  );
};
export default DropdownField;
